import { AxiosResponse } from 'axios'
import { buildServerApiUrl, getTenantId } from "../../Api/urls"
import { IUseAxiosOptions, useAxiosGet, useAxiosPost} from '../../Api/useAxios'

export interface IGetEmployeeCount {
     id : number,
     quarter : string,
     year: number, 
     count: number 
}

type TUseGetEmployeeCount = [
    {
        employeeCountInfo: IGetEmployeeCount[],
        loading: boolean,
        status?: string | number,
        errors: any[],
    },
    () => Promise<AxiosResponse<any> | undefined>
]


export const useGetEmployeeCountInfo = (toggle:boolean): TUseGetEmployeeCount => {
    if (toggle === false) 
    {
        return [{ employeeCountInfo: [], loading: false, status: 1, errors: [] }, async () => { return undefined }]
    }

const getEmployeeCountUrlPath = `${buildServerApiUrl("Benchmarking.GetEmployeeCount").toString()}/${getTenantId()}`

    const [{ data, loading, errors, status }, reFetchData] = useAxiosGet(
        getEmployeeCountUrlPath
    )
    let employeeCountInfo
    if (data) {
        employeeCountInfo = data
    }
    return [{ employeeCountInfo, loading, status, errors }, reFetchData]
}

export interface IUpsertEmployeeCountPayload {
     TenantId: string,
     Id : number,
     Quarter : string,
     Year: number, 
     Count: number
}

export type IUpsertEmployeeCount = Omit<IUpsertEmployeeCountPayload, "TenantId">

type TUpsertEmployeeCount = [
    (payload: IUpsertEmployeeCount) => Promise<AxiosResponse<any> | undefined>,
    {
        posting: boolean,
        status?: string | number,
        errors: any[],
    }
]

export const upsertEmployeeCountUrl = `${buildServerApiUrl("Benchmarking.UpsertEmployeeCount").toString()}`
export const upsertEmployeeCount = (
    options?: IUseAxiosOptions<IUpsertEmployeeCountPayload>
): TUpsertEmployeeCount => {

    const [upsert, { posting, status, errors }] = useAxiosPost<IUpsertEmployeeCountPayload>(
        upsertEmployeeCountUrl, {}, options
    )

    const upsertEmployeeCount = async (payload: IUpsertEmployeeCount) => {
        const res = await upsert({ ...payload , TenantId: getTenantId()})
        return res
    }

    return [upsertEmployeeCount, { posting, status, errors }]
}